import { post } from '../utils/ApiUtil';
import type { EditUserInfoParamDTO, UserInfoDTO } from './ProfileType';

const mock = false;

export const ProfileApi = {
  async queryUserInfo(userId: string): Promise<UserInfoDTO | null> {
    if (mock && false) {
      return null;
    }
    const result = await post<string, UserInfoDTO>('/sparrowUser/queryUserInfo', userId);
    if (typeof result === 'string') {
      return null;
    }
    return result;
  },

  async editUserInfo(param: EditUserInfoParamDTO): Promise<boolean> {
    if (mock && false) {
      return true;
    }
    const result = await post<EditUserInfoParamDTO, boolean>('/sparrowUser/editUserInfo', param);
    if (typeof result === 'string') {
      return false;
    }
    return !!result;
  },
};
